var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { Label } from 'reactstrap';
import styles from './GateInstructionDialog.module.scss';
import { Modal } from '@app/Components/Modal/Modal';
import { Input } from '@app/Components/Input/Input';
import { MarkdownViewer } from '@app/Components/MarkdownViewer/MarkdownViewer';
export var GateInstructionDialog = /** @class */ (function (_super) {
    __extends(GateInstructionDialog, _super);
    function GateInstructionDialog(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this._handleSaveClick = function () {
            var _a;
            var onSave = (_a = _this.props, _a.onSave), orgUnitConfigurationModel = _a.orgUnitConfigurationModel;
            orgUnitConfigurationModel.value = _this._value;
            onSave(orgUnitConfigurationModel);
        };
        _this._value = (_a = props.orgUnitConfigurationModel.value) !== null && _a !== void 0 ? _a : '';
        return _this;
    }
    GateInstructionDialog.prototype._handleChange = function (value) {
        this._value = value;
    };
    GateInstructionDialog.prototype.render = function () {
        var _a;
        var _this = this;
        var isOpen = (_a = this.props, _a.isOpen), onClose = _a.onClose, orgUnitConfigurationModel = _a.orgUnitConfigurationModel;
        return (React.createElement(Modal, { isOpen: isOpen, minWidth: "1100px", toggle: onClose, headerTitle: "".concat(orgUnitConfigurationModel.orgUnitDisplayName, " - Gate Instruction"), footerbuttons: this._getFooterButtons() },
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.section },
                    React.createElement(Label, null, "Gate Instruction (Markdown)"),
                    React.createElement(Input, { type: "textarea", rows: 12, value: this._value, onChange: function (e) { return _this._handleChange(e.target.value); } })),
                React.createElement("div", { className: styles.section },
                    React.createElement(Label, null, "Preview"),
                    React.createElement("div", { className: styles.preview },
                        React.createElement(MarkdownViewer, { value: this._value }))))));
    };
    GateInstructionDialog.prototype._getFooterButtons = function () {
        return [
            {
                color: 'success',
                onClick: this._handleSaveClick,
                title: 'Save'
            },
            {
                onClick: this.props.onClose,
                title: 'Close'
            }
        ];
    };
    __decorate([
        observable
    ], GateInstructionDialog.prototype, "_value", void 0);
    __decorate([
        action.bound
    ], GateInstructionDialog.prototype, "_handleChange", null);
    __decorate([
        action.bound
    ], GateInstructionDialog.prototype, "_handleSaveClick", void 0);
    GateInstructionDialog = __decorate([
        observer
    ], GateInstructionDialog);
    return GateInstructionDialog;
}(React.Component));
